import { call, put, takeLatest } from "redux-saga/effects";
import { hocSinhApi } from "../../../api/category/hocSinhApi";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { eEmailPhuHuynhActionTypeIds } from "../../action-types/don-hang/IEmailPhuHuynhActions";
import { rootActions } from "../../actions/rootActions";

export function* emailPhuHuynhSaga(): any {
    yield takeLatest(eEmailPhuHuynhActionTypeIds.LOAD_START, loadWorker);
}

function* loadWorker(action: any): any {
    const res: IBaseRespone = yield call(hocSinhApi.SelectParentEmails, { ts_hocsinh_id: action.payload })
    if (res.is_success) {
        yield put(rootActions.donHang.emailPhuHuynh.LOAD_SUCCESS(res.data))
    } else {
        yield put(rootActions.donHang.emailPhuHuynh.LOAD_ERROR(res.message ?? "Có lỗi"))
    }
}
